// extracted by mini-css-extract-plugin
module.exports = {"editScreen":"Details_Edit_editScreen__264pp","DefaultInputForm":"Details_Edit_DefaultInputForm__1pJbz","ErrorInputForm":"Details_Edit_ErrorInputForm__JiSTg"};